import { CtrlCollection } from "@yuigoto/ctrl";
import FaqData from "assets/data/faq.json";
import GlampartnerFaqData from "assets/data/glampartnerFaq.json";
import classnames from "classnames";
import AlertStyles from "components/alerts/Alert.module.scss";
import { Mastercard } from "components/creditcard/Mastercard";
import { Collapse } from "components/elements/Collapse";
import { Feedback } from "components/feedback/Feedback";
import { CreditCardInput } from "components/general/CreditCardInput";
import { FaqRenderer } from "components/general/FaqRenderer";
import { Paginator } from "components/general/Paginator";
import { Close } from "components/icons/Close";
import { Modal } from "components/modal/Modal";
import { Recurrence } from "components/pagamento/Recurrence";
import { IgButton, IgProfileContainer } from "components/person/Instagram";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { BeautyProfileControl } from "controls/BeautyProfileControl";
import { ElementsControl } from "controls/ElementsControl";
import React from "react";
import { connect } from "react-redux";
import LogBarView from "views/pages/LogBarView";


class Elements extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: false,
      subModalVisible: false,
      subSubModalVisible: false,
      feedbackModal: false,
      beautyProfileModalVisible: true
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleSubModal = this.toggleSubModal.bind(this);
    this.toggleSubSubModal = this.toggleSubSubModal.bind(this);
    this.submitFormTest = this.submitFormTest.bind(this);

    this.collection = new CtrlCollection();
    for (let n = 0; n < ElementsControl.length; n++) {
      this.collection.add(ElementsControl[n]);
    }
    //this.collection.invalidateAll();

    this.beautyProfileCollection = new CtrlCollection();
    for (let i = 0; i < BeautyProfileControl.length; i++) {
      this.beautyProfileCollection.add(BeautyProfileControl[i]);
    }
  }

  togglePerfilBeleza = () => {
    this.setState({
      beautyProfileModalVisible: !this.state.beautyProfileModalVisible
    })
  }

  submitFormTest(evt) {
    evt.preventDefault();

    let validate = this.collection.validate();

    if (validate) {

      this.forceUpdate();
    } else {

      this.forceUpdate();
    }
  }

  toggleModal() {
    this.setState({
      modalVisible: !this.state.modalVisible
    });
  }

  toggleSubModal() {
    this.setState({
      subModalVisible: !this.state.subModalVisible
    });
  }

  toggleSubSubModal() {
    this.setState({
      subSubModalVisible: !this.state.subSubModalVisible
    });
  }

  creditCardUpdateCallback = (obj) => {
  };

  updateValue = (questionId, value) => {
  };

  closeFeedbackModal = () => {
    this.setState({
      feedbackModal: !this.state.feedbackModal
    });
  };

  renderCollapseTest = () =>{
    return(
      <div>
        fdiodgjfghfdgrhugijbhseramgjbnhdogusekgjbrsgtekbj
        fdiodgjfghfdgrhugijbhseramgjbnhdogusekgjbrsgtekbj
        fdiodgjfghfdgrhugijbhseramgjbnhdogusekgjbrsgtekbj
        fdiodgjfghfdgrhugijbhseramgjbnhdogusekgjbrsgtekbj
        fdiodgjfghfdgrhugijbhseramgjbnhdogusekgjbrsgtekbj
      </div>
    );

  }

 
  render() {
    const { props, state } = this;

    return (
      <div className={"gb-page"}>
        <div className={"gb-page-contents"}>
          {/* <Modal visible ={this.state.beautyProfileModalVisible} 
             onCloseModal ={this.togglePerfilBeleza} 
             className={"modal__wrap-beautyprofile"}>
          <BeautyProfile></BeautyProfile>
        </Modal > */}

        <LogBarView value={50}/>
        <Collapse children={this.renderCollapseTest()}/>
          <Recurrence
            token={"Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJzZWN1cmUtYXBpIiwiYXVkIjoic2VjdXJlLWFwcCIsInN1YiI6ImZhYmlvLmdvdG9AYjRhZ3JvdXAuY29tfDM4OTY1OTQiLCJleHAiOjE1OTY4MzY5NDYsInJvbCI6WyJST0xFX1VTRVIiXX0.2AkFSz2JjT9oxJ49c45itk8E2I61ZbPS6LPH6EEIA5FkniAYKd1uM6h_U7UGAs527YKYia133EQDYBZZEmKCJQ"}
            isActive={true} />

          <h2 className={"style-guide__title"}>Feedback Teste</h2>

          <IgProfileContainer instagramInfo={props.person.insta} />

          <IgButton />
          <IgButton isActive={true} />

          <button className={"credit-card__change"}>
            <span className={"credit-card__change-flag"}>
              <Mastercard size={63} />
            </span>
            <span className={"credit-card__change-text"}>
              <span className={"number"}>
                ***********-7392
              </span>
              <span className={"expiry"}>
                Expira em: 12/2021
              </span>
            </span>
          </button>

          <Modal showCloseButton={true} visible={this.state.feedbackModal} onCloseModal={this.closeFeedbackModal} disableBackdropClose={true}>
            <Feedback id={5272} isProduct={true} onFinish={this.closeFeedbackModal} />
          </Modal>

          {/*
          <Modal showCloseButton={true} visible={this.state.feedbackModal} onCloseModal={this.closeFeedbackModal} disableBackdropClose={true}>
            <FeedbackForm id={5272} isProduct={true} onFinish={(data) => console.log(data)}/>
          </Modal>
          */}

          <hr />

          <CreditCardInput onSave={this.creditCardUpdateCallback} />

          <h2 className={"style-guide__title"}>
            FAQ
          </h2>

          <FaqRenderer title={"FAQ"} hideTitle={false} content={FaqData} />
          <FaqRenderer title={"FAQ"} hideTitle={false} content={GlampartnerFaqData} />

          <hr />

          <h2 className={"style-guide__title"}>
            Feedback
          </h2>

          {/*
          <FeedbackForm id={4906} isProduct={true} onFinish={() => {console.log("A");}}/>
          <FeedbackForm id={1766} onFinish={() => {console.log("A");}}/>
          */}

          <hr />

          <h2 className={"style-guide__title"}>
            Modal
          </h2>

          <p>O componente de modal recebe três parâmetros, além de itens <code>children</code>. Estes parâmetros são:</p>

          <ul>
            <li>
              <strong>
                <code>visible</code>
              </strong>: um valor boolean, obrigatório, indicando se o modal está visível ou não, deve ser fornecideo pelo componente pai
            </li>
            <li>
              <strong>
                <code>showCloseButton</code>
              </strong>: um callback, normalmente um método do componente pai que é executado para ocultar o modal (redefinindo o valor em <code>visible</code>)
            </li>
            <li>
              <strong>
                <code>showCloseButton</code>
              </strong>: um valor boolean, opcional, define se será exibido o botão de fechar padrão do modal
            </li>
          </ul>

          <br />

          <Modal visible={state.modalVisible}
            showCloseButton={true}
            useDefaultDialog={false}
            onCloseModal={this.toggleModal}>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In pellentesque congue semper. Aliquam cursus sit amet elit non iaculis. Fusce auctor tincidunt mi vitae egestas. Nunc ut luctus dolor. Cras nec blandit magna. In sodales quam ut lacus congue bibendum. Pellentesque viverra ornare pretium. Nunc euismod justo congue ipsum luctus, eget vehicula nunc iaculis. Vivamus placerat sagittis nisl, in tincidunt nisl elementum sed. Ut commodo dolor id metus tempor lacinia. Suspendisse mattis augue eget lacus accumsan, et pellentesque metus laoreet.</p>

            <p>Integer arcu erat, dictum ac congue et, pharetra vitae urna. Proin ex massa, blandit porttitor velit eget, lobortis fringilla quam. Ut sed nisl sed odio pretium dapibus. Vestibulum venenatis lorem vitae ligula aliquet, nec iaculis lectus volutpat. Maecenas hendrerit ac est non pharetra. Nullam faucibus eros quam, sit amet ornare lorem iaculis a. Suspendisse accumsan quam sodales, molestie massa id, rhoncus felis. Integer a justo vel leo ullamcorper venenatis. Nullam tincidunt mauris eget malesuada lacinia. Ut imperdiet luctus fringilla. Fusce pellentesque nunc ligula, non placerat tortor consequat vulputate.</p>

            <button className={"btn btn-light-lime mb-4"} onClick={this.toggleSubModal}>
              Tem mais um modal aqui!
            </button>

            <Modal visible={state.subModalVisible}
              showCloseButton={true}
              useDefaultDialog={true}
              onCloseModal={this.toggleSubModal}>
              <p>Nam semper sem non blandit ullamcorper. Aenean fermentum, nisl sit amet rutrum sodales, nibh diam porta neque, et cursus ex sapien sed neque. Cras lacinia aliquam nisi quis ultrices. Sed at risus vel ipsum imperdiet faucibus sed sed massa. Maecenas felis velit, venenatis vel mauris id, gravida gravida magna. Morbi lacus magna, rutrum quis enim tempor, elementum bibendum turpis. Morbi nisl justo, cursus ac mattis sit amet, ultricies eu turpis. Praesent dignissim ac tellus et ornare. Proin auctor suscipit euismod. Cras elementum congue accumsan. Pellentesque in enim porta, dictum ligula vel, gravida nulla.</p>
              <p>Nam semper sem non blandit ullamcorper. Aenean fermentum, nisl sit amet rutrum sodales, nibh diam porta neque, et cursus ex sapien sed neque. Cras lacinia aliquam nisi quis ultrices. Sed at risus vel ipsum imperdiet faucibus sed sed massa. Maecenas felis velit, venenatis vel mauris id, gravida gravida magna. Morbi lacus magna, rutrum quis enim tempor, elementum bibendum turpis. Morbi nisl justo, cursus ac mattis sit amet, ultricies eu turpis. Praesent dignissim ac tellus et ornare. Proin auctor suscipit euismod. Cras elementum congue accumsan. Pellentesque in enim porta, dictum ligula vel, gravida nulla.</p>
              <p>Nam semper sem non blandit ullamcorper. Aenean fermentum, nisl sit amet rutrum sodales, nibh diam porta neque, et cursus ex sapien sed neque. Cras lacinia aliquam nisi quis ultrices. Sed at risus vel ipsum imperdiet faucibus sed sed massa. Maecenas felis velit, venenatis vel mauris id, gravida gravida magna. Morbi lacus magna, rutrum quis enim tempor, elementum bibendum turpis. Morbi nisl justo, cursus ac mattis sit amet, ultricies eu turpis. Praesent dignissim ac tellus et ornare. Proin auctor suscipit euismod. Cras elementum congue accumsan. Pellentesque in enim porta, dictum ligula vel, gravida nulla.</p>

              <button className={"btn btn-light-lime mb-4"} onClick={this.toggleSubSubModal}>
                Modalception! (Pfv, não abuse disso)
              </button>

              <Modal visible={state.subSubModalVisible}
                showCloseButton={true}
                useDefaultDialog={true}
                onCloseModal={this.toggleSubSubModal}>
                <p>Nam semper sem non blandit ullamcorper. Aenean fermentum, nisl sit amet rutrum sodales, nibh diam porta neque, et cursus ex sapien sed neque. Cras lacinia aliquam nisi quis ultrices. Sed at risus vel ipsum imperdiet faucibus sed sed massa. Maecenas felis velit, venenatis vel mauris id, gravida gravida magna. Morbi lacus magna, rutrum quis enim tempor, elementum bibendum turpis. Morbi nisl justo, cursus ac mattis sit amet, ultricies eu turpis. Praesent dignissim ac tellus et ornare. Proin auctor suscipit euismod. Cras elementum congue accumsan. Pellentesque in enim porta, dictum ligula vel, gravida nulla.</p>
                <p>Nam semper sem non blandit ullamcorper. Aenean fermentum, nisl sit amet rutrum sodales, nibh diam porta neque, et cursus ex sapien sed neque. Cras lacinia aliquam nisi quis ultrices. Sed at risus vel ipsum imperdiet faucibus sed sed massa. Maecenas felis velit, venenatis vel mauris id, gravida gravida magna. Morbi lacus magna, rutrum quis enim tempor, elementum bibendum turpis. Morbi nisl justo, cursus ac mattis sit amet, ultricies eu turpis. Praesent dignissim ac tellus et ornare. Proin auctor suscipit euismod. Cras elementum congue accumsan. Pellentesque in enim porta, dictum ligula vel, gravida nulla.</p>
                <p>Nam semper sem non blandit ullamcorper. Aenean fermentum, nisl sit amet rutrum sodales, nibh diam porta neque, et cursus ex sapien sed neque. Cras lacinia aliquam nisi quis ultrices. Sed at risus vel ipsum imperdiet faucibus sed sed massa. Maecenas felis velit, venenatis vel mauris id, gravida gravida magna. Morbi lacus magna, rutrum quis enim tempor, elementum bibendum turpis. Morbi nisl justo, cursus ac mattis sit amet, ultricies eu turpis. Praesent dignissim ac tellus et ornare. Proin auctor suscipit euismod. Cras elementum congue accumsan. Pellentesque in enim porta, dictum ligula vel, gravida nulla.</p>
              </Modal>
            </Modal>
          </Modal>

          <button className={"btn btn-light-lime mb-4"} onClick={this.toggleModal}>
            Abre-te Sésamo!
          </button>

          <hr />

          <h2 className={"style-guide__title"}>
            Glambox Form Renderer (Ctrl)
          </h2>

          <form onSubmit={this.submitFormTest}>
            {/* GlamboxFormRenderer.renderCollection(this.beautyProfileCollection) */}
            {ControlRenderer.renderCollection(this.collection)}

            <input type={"submit"} value={"enviar"} />
          </form>

          <hr />

          <h2 className={"style-guide__title"}>
            Glamclub (Listagem)
          </h2>

          {/*
          <ProductDetails product={ProductData}/>
          <ProductComments comments={ProductComments}  rating={ProductData.ratingAverage}/>
          */}

          <Paginator page={1} perPage={12} totalItems={146} baseUrl={"/produtos/"} />

          <hr />

          <h2 className={"style-guide__title"}>
            Alertas
          </h2>

          <div className={AlertStyles["alerts__feed"]}>
            <div className={classnames(AlertStyles["alerts__item"])}>
              <div className={AlertStyles["alerts__item-data"]}>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas quis mollis augue. Quisque sagittis velit sit amet dignissim vestibulum. Nunc non ligula sed lacus hendrerit semper sed at diam.</p>
              </div>
              <button className={AlertStyles["alerts__item-button"]}>
                <Close fill={"rgba(0, 0, 0, .25)"} width={"100%"} height={"100%"} />
              </button>
            </div>

            <div className={classnames(AlertStyles["alerts__item"], AlertStyles["success"])}>
              <div className={AlertStyles["alerts__item-data"]}>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas quis mollis augue. Quisque sagittis velit sit amet dignissim vestibulum. Nunc non ligula sed lacus hendrerit semper sed at diam.</p>
              </div>
              <button className={AlertStyles["alerts__item-button"]}>
                <Close fill={"rgba(0, 0, 0, .25)"} width={"100%"} height={"100%"} />
              </button>
            </div>

            <div className={classnames(AlertStyles["alerts__item"], AlertStyles["error"])}>
              <div className={AlertStyles["alerts__item-data"]}>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas quis mollis augue. Quisque sagittis velit sit amet dignissim vestibulum. Nunc non ligula sed lacus hendrerit semper sed at diam.</p>
              </div>
              <button className={AlertStyles["alerts__item-button"]}>
                <Close fill={"rgba(0, 0, 0, .25)"} width={"100%"} height={"100%"} />
              </button>
            </div>
          </div>

          <hr />

          <h2 className={"style-guide__title"}>
            Formulários Básicos
          </h2>

          <form onSubmit={(e) => { e.preventDefault(); }}>
            <input type={"text"} />
            <input type={"url"} />
            <input type={"email"} />
            <input type={"number"} />
            <input type={"tel"} />
            <input type={"date"} />
            <input type={"password"} />
            <select>
              <optgroup label={"Option Group"}>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
              </optgroup>
            </select>
            <textarea></textarea>
            <input type={"checkbox"} />
            <input type={"radio"} />
          </form>

          <hr />

          <h2 className={"style-guide__title"}>
            Formulários Glambox
          </h2>

          <form onSubmit={(e) => { e.preventDefault(); }}>
            <input className={"form-control"} type={"text"} />
            <input className={"form-control"} type={"url"} />
            <input className={"form-control"} type={"email"} />
            <input className={"form-control"} type={"number"} />
            <input className={"form-control"} type={"tel"} />
            <input className={"form-control"} type={"date"} />
            <input className={"form-control"} type={"password"} />
            <select className={"form-control"}>
              <optgroup label={"Option Group"}>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
              </optgroup>
            </select>
            <select className={"form-control"} multiple>
              <optgroup label={"Option Group"}>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
              </optgroup>
              <optgroup label={"Option Group"}>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
              </optgroup>
              <optgroup label={"Option Group"}>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
                <option value={"1"}>Option Value</option>
              </optgroup>
            </select>
            <textarea className={"form-control"}></textarea>

            {/* TOGGLEZINHO É DA ISA */}

            <div>
              <div className={"form-check form-check-inline"}>
                <input className={"form-check-input"} type={"checkbox"} defaultChecked={true} />
                <label className={"form-check-label"}>
                  Input Label
                </label>
              </div>
              <div className={"form-check form-check-inline"}>
                <input className={"form-check-input"} type={"checkbox"} />
                <label className={"form-check-label"}>
                  Input Label
                </label>
              </div>
              <div className={"form-check form-check-inline"}>
                <input className={"form-check-input"} type={"checkbox"} disabled />
                <label className={"form-check-label"}>
                  Input Label
                </label>
              </div>
              <p className={"form-info"}>
                Lorem ipsum dolor sit amet, consectetur.
              </p>
            </div>

            <div>
              <div className={"custom-control custom-checkbox"}>
                <label className={"custom-control-label"}>
                  <input type={"checkbox"} className={"custom-control-input"} defaultChecked={true} />
                  <span></span>
                  Lorem ipsum dolor sit amet, consectetur.
                </label>
              </div>
              <div className={"custom-control custom-checkbox"}>
                <label className={"custom-control-label"}>
                  <input type={"checkbox"} className={"custom-control-input"} />
                  <span></span>
                  Lorem ipsum dolor sit amet, consectetur.
                </label>
              </div>
              <div className={"custom-control custom-checkbox"}>
                <label className={"custom-control-label"}>
                  <input type={"checkbox"} className={"custom-control-input"} disabled />
                  <span></span>
                  Lorem ipsum dolor sit amet, consectetur.
                </label>
              </div>
            </div>

            <div>
              <div className={"custom-control custom-radio"}>
                <label className={"custom-control-label"}>
                  <input type={"radio"} className={"custom-control-input"} defaultChecked={true} />
                  <span></span>
                  Lorem ipsum dolor sit amet, consectetur.
                </label>
              </div>
              <div className={"custom-control custom-radio"}>
                <label className={"custom-control-label"}>
                  <input type={"radio"} className={"custom-control-input"} />
                  <span></span>
                  Lorem ipsum dolor sit amet, consectetur.
                </label>
              </div>
              <div className={"custom-control custom-radio"}>
                <label className={"custom-control-label"}>
                  <input type={"radio"} className={"custom-control-input"} disabled />
                  <span></span>
                  Lorem ipsum dolor sit amet, consectetur.
                </label>
              </div>
            </div>

            <div className={"form-check"}>
              <input className={"form-check-input"} type={"checkbox"} defaultChecked={true} />
              <label className={"form-check-label"}>
                Input Label
              </label>
            </div>
            <div className={"form-check"}>
              <input className={"form-check-input"} type={"checkbox"} />
              <label className={"form-check-label"}>
                Input Label
              </label>
            </div>
            <div className={"form-check"}>
              <input className={"form-check-input"} type={"checkbox"} disabled />
              <label className={"form-check-label"}>
                Input Label
              </label>
            </div>
            <div className={"form-check"}>
              <input className={"form-check-input"} name={"radios"} type={"radio"} defaultChecked={true} />
              <label className={"form-check-label"}>
                Input Label
              </label>
            </div>
            <div className={"form-check"}>
              <input className={"form-check-input"} name={"radios"} type={"radio"} />
              <label className={"form-check-label"}>
                Input Label
              </label>
            </div>
            <div className={"form-check"}>
              <input className={"form-check-input"} name={"radios"} type={"radio"} disabled />
              <label className={"form-check-label"}>
                Input Label
              </label>
            </div>
          </form>

          <h4>Form Groups, Row, Input Groups</h4>

          <form>
            <div className={"form-group"}>
              <label>
                This is a Label <small>Hello</small>
              </label>
              <input type={"text"} className={"form-control"} />
            </div>
            <div className={"form-group"}>
              <label>
                This is a Label <small>Hello</small>
              </label>
              <div className={"form-check"}>
                <input className={"form-check-input"} name={"radios"} type={"radio"} />
                <label className={"form-check-label"}>
                  Input Label
                </label>
              </div>
              <div className={"form-check"}>
                <input className={"form-check-input"} name={"radios"} type={"radio"} disabled />
                <label className={"form-check-label"}>
                  Input Label
                </label>
              </div>
            </div>
            <div className={"form-group"}>
              <label>
                This is a Label <small>Hello</small>
              </label>
              <div className={"form-check"}>
                <input className={"form-check-input"} name={"radios"} type={"radio"} />
                <label className={"form-check-label"}>
                  Input Label
                </label>
              </div>
              <div className={"form-check"}>
                <input className={"form-check-input"} name={"radios"} type={"radio"} disabled />
                <label className={"form-check-label"}>
                  Input Label
                </label>
              </div>
            </div>
            <div className={"form-group"}>
              <label>
                This is a Label
              </label>
              <input type={"text"} className={"form-control"} />
              <div className={"form-feedback"}>
                <p>Lorem ipsum dolor sit amet, consectetur.</p>
              </div>
              <div className={"form-feedback invalid-feedback"}>
                <p>Lorem ipsum dolor sit amet, consectetur.</p>
              </div>
              <div className={"form-feedback valid-feedback"}>
                <p>Lorem ipsum dolor sit amet, consectetur.</p>
              </div>
            </div>
            <div className={"form-row"}>
              <div className={"form-group col-4"}>
                <label>
                  This is a Label
                </label>
                <input type={"text"} className={"form-control"} />
                <p className={"form-info"}>
                  Lorem ipsum dolor sit amet, consectetur.
                </p>
              </div>
              <div className={"form-group col-4"}>
                <label>
                  This is a Label
                </label>
                <input type={"text"} className={"form-control"} />
              </div>
              <div className={"form-group col-4"}>
                <label>
                  This is a Label
                </label>
                <input type={"text"} className={"form-control"} />
              </div>
            </div>
          </form>

          <hr />

          <h2 className={"style-guide__title"}>
            Tipografia Básica
          </h2>

          <h1>Heading 1 <small>(Small)</small></h1>
          <h2>Heading 2 <small>(Small)</small></h2>
          <h3>Heading 3 <small>(Small)</small></h3>
          <h4>Heading 4 <small>(Small)</small></h4>
          <h5>Heading 5 <small>(Small)</small></h5>
          <h6>Heading 6 <small>(Small)</small></h6>

          <span className={"h1"}>.h1 Heading <small>(Small)</small></span>
          <span className={"h2"}>.h2 Heading <small>(Small)</small></span>
          <span className={"h3"}>.h3 Heading <small>(Small)</small></span>
          <span className={"h4"}>.h4 Heading <small>(Small)</small></span>
          <span className={"h5"}>.h5 Heading <small>(Small)</small></span>
          <span className={"h6"}>.h6 Heading <small>(Small)</small></span>

          <h1 className={"display-1"}>Display 1 (Style Guide)</h1>
          <h2 className={"display-2"}>Display 2 (Style Guide)</h2>
          <h3 className={"display-3"}>Display 3 (Style Guide)</h3>

          <p className={"subtitle"}>Subtitle: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

          <p className={"caption"}>Caption: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

          <p className={"caption line"}>Caption Line: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

          <p className={"small"}>Small: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

          <p className={"text-muted"}>Text Muted: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

          <p className={"lead"}>Lead: Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

          <p>Lorem ipsum dolor sit amet, <a href={"/"}>consectetur</a> adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>

          <p>
            <a href={"/"}>
              Link
            </a>
            &nbsp;
            <a href={"/"}>
              Link
            </a>
            &nbsp;
            <a href={"/"}>
              Link
            </a>
            &nbsp;
            <a href={"/"} className={"disabled"}>
              Link
            </a>
          </p>

          <hr />

          <h2 className={"style-guide__title"}>
            Grid e Layout
          </h2>

          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-1 grid-test"}>col-1</div>
              <div className={"col-11 grid-test"}>col-11</div>
            </div>
            <div className={"row"}>
              <div className={"col-2 grid-test"}>col-2</div>
              <div className={"col-10 grid-test"}>col-10</div>
            </div>
            <div className={"row"}>
              <div className={"col-3 grid-test"}>col-3</div>
              <div className={"col-9 grid-test"}>col-9</div>
            </div>
            <div className={"row"}>
              <div className={"col-4 grid-test"}>col-4</div>
              <div className={"col-8 grid-test"}>col-8</div>
            </div>
            <div className={"row"}>
              <div className={"col-5 grid-test"}>col-5</div>
              <div className={"col-7 grid-test"}>col-7</div>
            </div>
            <div className={"row"}>
              <div className={"col-6 grid-test"}>col-6</div>
              <div className={"col-6 grid-test"}>col-6</div>
            </div>
            <div className={"row"}>
              <div className={"col-7 grid-test"}>col-7</div>
              <div className={"col-5 grid-test"}>col-5</div>
            </div>
            <div className={"row"}>
              <div className={"col-8 grid-test"}>col-8</div>
              <div className={"col-4 grid-test"}>col-4</div>
            </div>
            <div className={"row"}>
              <div className={"col-9 grid-test"}>col-9</div>
              <div className={"col-3 grid-test"}>col-3</div>
            </div>
            <div className={"row"}>
              <div className={"col-10 grid-test"}>col-10</div>
              <div className={"col-2 grid-test"}>col-2</div>
            </div>
            <div className={"row"}>
              <div className={"col-11 grid-test"}>col-11</div>
              <div className={"col-1 grid-test"}>col-1</div>
            </div>
            <div className={"row"}>
              <div className={"col-12 grid-test"}>col-12</div>
            </div>
          </div>

          <h4>Reordenação de Colunas</h4>

          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-6 order-2 order-lg-1 grid-test"}>
                .col-6 .order-2 .order-lg-1
              </div>
              <div className={"col-6 order-1 order-lg-2 grid-test"}>
                .col-6 .order-1 .order-lg-2
              </div>
            </div>
          </div>

          <h4>Alinhamento de Itens</h4>

          <div className={"container"}>
            <div className={"row align-items-center"}>
              <div className={"col-4 grid-test"}>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid eius laboriosam minus modi mollitia unde ut.</p>
              </div>
              <div className={"col-4 grid-test"}>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A alias atque consequatur cum deleniti doloremque doloribus ea excepturi fuga illum nisi numquam, quae quisquam suscipit tempora temporibus unde voluptas voluptatem.</p>
              </div>
              <div className={"col-4 grid-test"}>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid eius laboriosam minus modi mollitia unde ut.</p>
              </div>
            </div>
          </div>

          <hr />

          <h2 className={"style-guide__title"}>
            Botões
          </h2>

          <h4>Anchors</h4>

          <p>
            <a href={"/"} className={"btn"}>
              Hello
            </a>
            <a href={"/"} className="btn btn-light-violet">
              Button
            </a>
            <a href={"/"} className="btn btn-violet">
              Button
            </a>
            <a href={"/"} className="btn btn-light-pink">
              Button
            </a>
            <a href={"/"} className="btn btn-pink">
              Button
            </a>
            <a href={"/"} className="btn btn-light-yellow">
              Button
            </a>
            <a href={"/"} className="btn btn-yellow">
              Button
            </a>
            <a href={"/"} className="btn btn-light-lime">
              Button
            </a>
            <a href={"/"} className="btn btn-lime">
              Button
            </a>
            <a href={"/"} className="btn btn-light-blue">
              Button
            </a>
            <a href={"/"} className="btn btn-blue">
              Button
            </a>
          </p>

          <h4>Buttons</h4>

          <p>
            <button className={"btn"} type={"button"}>
              Hello
            </button>
            <button className="btn btn-light-violet" type="button">
              Button
            </button>
            <button className="btn btn-violet" type="button">
              Button
            </button>
            <button className="btn btn-light-pink" type="button">
              Button
            </button>
            <button className="btn btn-pink" type="button">
              Button
            </button>
            <button className="btn btn-light-yellow" type="button">
              Button
            </button>
            <button className="btn btn-yellow" type="button">
              Button
            </button>
            <button className="btn btn-light-lime" type="button">
              Button
            </button>
            <button className="btn btn-lime" type="button">
              Button
            </button>
            <button className="btn btn-light-blue" type="button">
              Button
            </button>
            <button className="btn btn-light-blue" type="button" disabled>
              Button
            </button>
            <button className="btn btn-blue" type="button">
              Button
            </button>
            <button className="btn btn-blue disabled" type="button">
              Button
            </button>
            <button className="btn btn-white" type="button">
              Button
            </button>
            <button className="btn btn-white disabled" type="button">
              Button
            </button>
          </p>

          <h4>Buttons (Outline)</h4>

          <p>
            <button className="btn btn-outline-light-violet" type="button">
              Button
            </button>
            <button className="btn btn-outline-violet" type="button">
              Button
            </button>
            <button className="btn btn-outline-light-pink" type="button">
              Button
            </button>
            <button className="btn btn-outline-pink" type="button">
              Button
            </button>
            <button className="btn btn-outline-light-yellow" type="button">
              Button
            </button>
            <button className="btn btn-outline-yellow" type="button">
              Button
            </button>
            <button className="btn btn-outline-light-lime" type="button">
              Button
            </button>
            <button className="btn btn-outline-lime" type="button">
              Button
            </button>
            <button className="btn btn-outline-light-blue" type="button">
              Button
            </button>
            <button className="btn btn-outline-light-blue disabled" type="button">
              Button
            </button>
            <button className="btn btn-outline-blue" type="button">
              Button
            </button>
            <button className="btn btn-outline-blue" type="button" disabled>
              Button
            </button>
            <span className="black-box">
              <button className="btn btn-outline-white" type="button">
                Button
            </button>
              <button className="btn btn-outline-white" type="button" disabled>
                Button
            </button>
            </span>
          </p>

          <h4>Large/Small</h4>

          <p>
            <button className="btn btn-lg btn-outline-light-blue" type="button">
              Button
            </button>
            <br />
            <br />
            <button className="btn btn-sm btn-outline-blue" type="button">
              Button
            </button>
          </p>

          <hr />

          <h2 className={"style-guide__title"}>
            Spacing (margin/padding)
          </h2>

          <span className={"p-0 spacing-block"}><code>.p-0</code></span>
          <span className={"p-1 spacing-block"}><code>.p-1</code></span>
          <span className={"p-2 spacing-block"}><code>.p-2</code></span>
          <span className={"p-3 spacing-block"}><code>.p-3</code></span>
          <span className={"p-4 spacing-block"}><code>.p-4</code></span>
          <span className={"p-5 spacing-block"}><code>.p-5</code></span>
          <span className={"p-6 spacing-block"}><code>.p-6</code></span>
          <span className={"p-7 spacing-block"}><code>.p-7</code></span>

          <span className={"margin-example"}>
            <span className={"m-0 spacing-block"}><code>.m-0</code></span>
          </span>
          <span className={"margin-example"}>
            <span className={"m-1 spacing-block"}><code>.m-1</code></span>
          </span>
          <span className={"margin-example"}>
            <span className={"m-2 spacing-block"}><code>.m-2</code></span>
          </span>
          <span className={"margin-example"}>
            <span className={"m-3 spacing-block"}><code>.m-3</code></span>
          </span>
          <span className={"margin-example"}>
            <span className={"m-4 spacing-block"}><code>.m-4</code></span>
          </span>
          <span className={"margin-example"}>
            <span className={"m-5 spacing-block"}><code>.m-5</code></span>
          </span>
          <span className={"margin-example"}>
            <span className={"m-6 spacing-block"}><code>.m-6</code></span>
          </span>
          <span className={"margin-example"}>
            <span className={"m-7 spacing-block"}><code>.m-7</code></span>
          </span>

          <hr />

          <h2 className={"style-guide__title"}>
            Drop Shadow Levels
          </h2>

          <span className={"shadow-test d-inline-block p-2 level-1"}>.level-1</span>
          <span className={"shadow-test d-inline-block p-2 level-2"}>.level-2</span>
          <span className={"shadow-test d-inline-block p-2 level-3"}>.level-3</span>
          <span className={"shadow-test d-inline-block p-2 level-4"}>.level-4</span>
          <span className={"shadow-test d-inline-block p-2 level-5"}>.level-5</span>
          <span className={"shadow-test d-inline-block p-2 level-6"}>.level-6</span>
          <span className={"shadow-test d-inline-block p-2 level-7"}>.level-7</span>
          <span className={"shadow-test d-inline-block p-2 level-8"}>.level-8</span>

          <hr />

          <h2 className={"style-guide__title"}>
            Blocos de Conteúdo
          </h2>

          <div className={"gb-contentblock p-4 level-2"}>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi error molestias repellat sapiente sint ut, voluptatum.</p>
            <p>Aliquam, doloremque doloribus incidunt mollitia saepe vel. Aliquam consectetur dolores earum exercitationem possimus qui quidem repudiandae.</p>
            <p>Nemo non provident similique vitae voluptas? Deleniti dolore doloremque labore officia officiis saepe sed sequi sit.</p>
          </div>
        </div>
      </div>
    );
  }


}

const mapStateToProps = (state) => ({
  person: state.person.data,
  editions: state.editions,
  subscribers: state.subscribers.data,
  token: state.token.data,
  partnerInfo: state.partnerInfo.data,
});

Elements = connect(mapStateToProps)(Elements);

export { Elements };

